<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">分校學生編號表</div>
        </el-col>
        <el-col style="text-align: right;">
          <div style="display: flex; justify-content: flex-end; align-items: center;">
            <importExcel @importExcel="importExcel"></importExcel>
             <el-button type="info"  @click="onAdd">新增編號</el-button>
          </div>
        </el-col>
      </el-row>
      <div class="page-box">
        <div class="page-box-content">
          <div class="page-box-content-row">
            <div>
              <div class="search-text">分校學生編號</div>
              <el-input
                v-model="formLabelAlign.numberLike"
                placeholder="搜尋分校學生編號"
              ></el-input>
            </div>
            <div>
              <div class="search-text">電話號碼</div>
              <el-input
                v-model="formLabelAlign.phoneLike"
                placeholder=" 搜尋電話號碼"
              ></el-input>
            </div>
            <div>
              <el-button type="info" class="button-el-el" @click.native="onSearch"
                >搜尋</el-button
              >
            </div>
            <div>
              <el-button
                type="success"
                class="button-el-el"
                @click.native="onReset"
                >清除篩選</el-button
              >
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column sortable="custom" prop="number" label="分校學生編號" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.number }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="電話號碼"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="chineseName"
              label="學生名字"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.engName }} {{ row.given }} {{ row.surname }} {{ row.chineseName }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="teacherName"
              label="老師名字"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.teacherName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="狀態"
            align="center"
           
          >
            <template slot-scope="{ row }">
              <span :class="{'studentCode': row.status==1,'isStudentCode':row.status==0}">{{ row.status | studentCodeStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
             <el-button
                type="text"
                size="medium"
                @click="onEdit(row, row.id)"
                >編輯</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getStudentCodes"
    />
    <dialogSlotVisible :centerDialogVisible="centerDialogVisible">
      <div>{{ title }}</div>
      <el-form  :model="formInline" ref="ruleForm" :rules="rules" :hide-required-asterisk="true" class="demo-form-inline">
          <el-form-item prop="number" :rules="[{
            required: true,
            message: '請輸入分校學生編號',
            trigger: 'blur',
          }]">
            <div slot="label">
              <div class="label-text">
                分校學生編號
                <span class="star-mark"> *</span>
              </div>
            </div>
           <el-input v-model="formInline.number" placeholder=""></el-input>
          </el-form-item>
          <el-form-item prop="phone" :rules="[{
            required: true,
            message: '請輸入電話號碼',
            trigger: 'blur'
          }]">
             <div slot="label">
              <div class="label-text">
                電話號碼
                <span class="star-mark"> *</span>
              </div>
            </div>
           <el-input v-model.number="formInline.phone" placeholder=""></el-input>
          </el-form-item>
        <el-form-item prop="chineseName">
          <div slot="label">
            <div class="label-text">
              分校學生ChineseName
            </div>
          </div>
          <el-input v-model="formInline.chineseName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item prop="engName">
          <div slot="label">
            <div class="label-text">
              分校學生EngName
            </div>
          </div>
          <el-input v-model="formInline.engName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item prop="given">
          <div slot="label">
            <div class="label-text">
              分校學生Given
            </div>
          </div>
          <el-input v-model="formInline.given" placeholder=""></el-input>
        </el-form-item>
        <el-form-item prop="surname">
          <div slot="label">
            <div class="label-text">
              分校學生Surname
            </div>
          </div>
          <el-input v-model="formInline.surname" placeholder=""></el-input>
        </el-form-item>
        <el-form-item prop="surname">
          <div slot="label">
            <div class="label-text">
              分校老師
            </div>
          </div>
          <el-input v-model="formInline.teacherName" placeholder=""></el-input>
        </el-form-item>
    </el-form>
      <div class="page-button">
        <el-button type="info" @click="onConfirm">確定</el-button>
        <el-button type="success" @click="onCancel">取消</el-button>
      </div>
    </dialogSlotVisible>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getStudentCodes,addStudentCodes ,editStudentCodes} from "@/api/setting";
import dialogSlotVisible from "@/components/dialogSlotVisible";
import importExcel from "./components/importExcel";
export default {
  components: { dialogSlotVisible, Pagination,importExcel },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "未選用" : "已認證";
    },
  },
  data() {
    return {
      itemId: 0,
      total: 0,
      title:'',
      payStatus: [],
      orderId: null,
      formInline:{
        number:'',
        phone:'',
        chineseName:'',
        teacherName:'',
        engName:'',
        given:'',
        surname:'',
      },
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        numberLike: null,
        phoneLike: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
      rules:{}
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getStudentCodes();
  },

  methods: {
    importExcel(){
      this.getStudentCodes()
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getStudentCodes();
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if (key === "_page") {
          this.formLabelAlign[key] = 1;
        } else if (key === "_limit") {
          this.formLabelAlign[key] = 50;
        }
      })
      this.getStudentCodes();
    },
    onSearch() {
      this.getStudentCodes();
    },
    onCancel() {
      this.centerDialogVisible = false;
    },
    onConfirm() {
       this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (this.itemId != null) {
              this.editStudentCodes();
            } else {
              this.addStudentCodes();
            }
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
     
    },
    onEdit(row, id) {
      this.title = '編輯'
      this.formInline.number = row.number;
      this.formInline.phone = row.phone;
      this.formInline.chineseName = row.chineseName;
      this.formInline.teacherName = row.teacherName;
      this.formInline.engName = row.engName;
      this.formInline.given = row.given;
      this.formInline.surname = row.surname;

      this.itemId = id;
      this.centerDialogVisible = true;
    },
    onAdd() {
      this.title = '新增';
      this.formInline.phone = null;
      this.formInline.number = null;
      this.formInline.chineseName = null;
      this.formInline.teacherName = null;
      this.formInline.engName = null;
      this.formInline.given = null;
      this.formInline.surname = null;
      this.itemId = null;
      this.centerDialogVisible = true;
    },
     //編輯
    editStudentCodes() {
      let from = {
        number: this.formInline.number,
        phone: this.formInline.phone,
        chineseName: this.formInline.chineseName,
        teacherName: this.formInline.teacherName,
        engName: this.formInline.engName,
        given: this.formInline.given,
        surname: this.formInline.surname,
      };
      editStudentCodes(this.itemId, from)
        .then(() => {
          this.getStudentCodes();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    addStudentCodes() {
      let from = {
        number: this.formInline.number,
        phone: this.formInline.phone,
        chineseName: this.formInline.chineseName,
        teacherName: this.formInline.teacherName,
        engName: this.formInline.engName,
        given: this.formInline.given,
        surname: this.formInline.surname,
      };
      addStudentCodes(from)
        .then(() => {
          this.getStudentCodes();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    }, 
    getStudentCodes() {
      let formLabelAlign = {
        phoneLike: this.formLabelAlign.phoneLike,
        numberLike: this.formLabelAlign.numberLike,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getStudentCodes(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
}
.studentCode{
  color: #027915;
}
.isStudentCode{
  color: #9C0000;
}
.page-box-content{
  width: 100%;
  overflow-x: auto;
}
.page-box-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(4, 170px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}

</style>